/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. All calculations happen locally in your browser using JavaScript — your date of birth is never sent to a server, logged, or stored anywhere, and it disappears the moment you close or refresh the page. Nothing is saved or shared with third parties.`)
};

const es_age_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Todos los cálculos ocurren localmente en tu navegador usando JavaScript — tu fecha de nacimiento nunca se envía a un servidor, se registra o se almacena en ningún lugar, y desaparece en el momento en que cierras o actualizas la página. Nada se guarda ni se comparte con terceros.`)
};

const de_age_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Alle Berechnungen erfolgen lokal in Ihrem Browser mit JavaScript — Ihr Geburtsdatum wird niemals an einen Server gesendet, protokolliert oder irgendwo gespeichert, und es verschwindet in dem Moment, in dem Sie die Seite schließen oder aktualisieren. Nichts wird gespeichert oder mit Dritten geteilt.`)
};

const nl_age_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Alle berekeningen gebeuren lokaal in uw browser met behulp van JavaScript — uw geboortedatum wordt nooit naar een server gestuurd, geregistreerd of ergens opgeslagen, en het verdwijnt op het moment dat u de pagina sluit of vernieuwt. Er wordt niets opgeslagen of gedeeld met derden.`)
};

const fr_age_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Tous les calculs se font localement dans votre navigateur à l'aide de JavaScript — votre date de naissance n'est jamais envoyée à un serveur, enregistrée ou stockée n'importe où, et elle disparaît dès que vous fermez ou actualisez la page. Rien n'est enregistré ou partagé avec des tiers.`)
};

const it_age_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Tutti i calcoli avvengono localmente nel tuo browser utilizzando JavaScript — la tua data di nascita non viene mai inviata a un server, registrata o archiviata da nessuna parte, e scompare nel momento in cui chiudi o aggiorni la pagina. Niente viene salvato o condiviso con terze parti.`)
};

const pt_br2_age_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Todos os cálculos acontecem localmente no seu navegador usando JavaScript — sua data de nascimento nunca é enviada para um servidor, registrada ou armazenada em qualquer lugar, e desaparece no momento em que você fecha ou atualiza a página. Nada é salvo ou compartilhado com terceiros.`)
};

const pt_age_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Todos os cálculos acontecem localmente no seu navegador usando JavaScript — a sua data de nascimento nunca é enviada para um servidor, registada ou armazenada em qualquer lugar, e desaparece no momento em que fecha ou atualiza a página. Nada é guardado ou partilhado com terceiros.`)
};

const ja_age_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。すべての計算はJavaScriptを使用してブラウザでローカルに実行されます - 生年月日はサーバーに送信されたり、ログに記録されたり、どこにも保存されたりすることはなく、ページを閉じたり更新したりした時点で消えます。何も保存されたり、第三者と共有されたりしません。`)
};

const zh_age_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。所有计算都通过 JavaScript 在您的浏览器本地完成——您的出生日期不会被发送到服务器、记录或存储在任何地方，一旦您关闭或刷新页面，它就会立即消失。没有任何数据会被保存或分享给第三方。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_faq3_a", locale)
	if (locale === "en") return en_age_faq3_a(inputs)
	if (locale === "es") return es_age_faq3_a(inputs)
	if (locale === "de") return de_age_faq3_a(inputs)
	if (locale === "nl") return nl_age_faq3_a(inputs)
	if (locale === "fr") return fr_age_faq3_a(inputs)
	if (locale === "it") return it_age_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_age_faq3_a(inputs)
	if (locale === "pt") return pt_age_faq3_a(inputs)
	if (locale === "ja") return ja_age_faq3_a(inputs)
	return zh_age_faq3_a(inputs)
};